<template>
  <section class="world-background-green">
    <cards-roulette :options="options" :type="'capital_program_types'" />
  </section>
</template>

<script>
import CapitalProgramTypes from '@/constants/capital_program_types.js'
import CardsRoulette from '@/components/on-board/CardsRoulette.vue'
import OnBoardStepMixin from '@/mixins/onBoardStepMixin.js'


export default {
  mixins: [OnBoardStepMixin],
  components: { CardsRoulette },
  data() {
    return {
      options: []
    }
  },
  mounted() {
    this.options = CapitalProgramTypes
  }
}
</script>
